/** The name a person sees for one of their workspaces: "Personal workspace" or the organization's name. */
const getWorkspaceLabel = (company) => {
  return company?.isPersonal ? 'Personal workspace' : company?.name || '';
};

export default getWorkspaceLabel;
